import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

interface ReplaceAnswerModalProps {
  open: boolean;
  toggle: () => void;
  handleConfirm: () => void;
}

export const ReplaceAnswerModal = ({ open, toggle, handleConfirm }: ReplaceAnswerModalProps) => {
  return (
    <Modal isOpen={open} toggle={toggle} backdrop='static'>
      <ModalHeader toggle={toggle}>
        <span className='text-ThemeWarningExtraDark'>Replace answer?</span>
      </ModalHeader>
      <ModalBody>
        <p className='mb-0'>
          This field already has a value/content in it. If you proceed this value will be replaced with the answer you
          have selected in the sidebar.
        </p>
      </ModalBody>
      <ModalFooter className='pt-0'>
        <Button color='link-secondary' onClick={toggle}>
          Cancel
        </Button>
        <Button color='warning' onClick={handleConfirm}>
          Replace answer
        </Button>
      </ModalFooter>
    </Modal>
  );
};
